export var schema = {
  title: "Property Loss",
  description: "Property Loss Claim Form",
  type: "object",
  properties: {
    insured: {
      type: "object",
      title: "Insured",
      required: ["insuredName", "insuredPolicyNumber", "brokeremail"],
      properties: {
        insuredName: {
          type: "string",
          title: "Name of Insured"
        },
        insuredPolicyNumber: {
          type: "string",
          title: "Policy Number"
        },
        insuredContactPerson: {
          type: "string",
          title: "Contact Person"
        },
        insuredContactNumber: {
          type: "string",
          title: "Contact Phone Number"
        },
        insuredContactEmail: {
          type: "string",
          title: "Contact Email Address",
          format: "email"
        },
        insuredVatNumber: {
          type: "string",
          title: "VAT Number"
        },
        brokeremail: {
          type: "string",
          title: "Broker Email",
          format: "email"
        }
      }
    },
    incident: {
      type: "object",
      title: "Incident",
      properties: {
        incidentdate: {
          title: "Date of Incident",
          type: "string",
          format: "date-time"
        },
        incidentplace: {
          type: "string",
          title: "Place of Loss"
        },
        incidentestimate: {
          type: "string",
          title: "Estimate"
        },
        incidentisCovered: {
          type: "boolean",
          title: "Is this incident covered under any other policy of insurance?"
        }
      }
    },
    police: {
      type: "object",
      title: "Police",
      properties: {
        policeplaceReported: {
          title: "Place where Reported",
          type: "string"
        },
        policedateReported: {
          title: "Date of Reporting",
          type: "string",
          format: "date"
        },
        policecaseNumber: {
          title: "Case Number (If Reported)",
          type: "string"
        }
      }
    },
    otherParty: {
      type: "object",
      title: "Loss Caused by Other Parties",
      properties: {
        otherPartyName: {
          title: "Name",
          type: "string"
        },
        otherPartyContactNumber: {
          title: "Contact Phone Number",
          type: "string"
        },
        otherPartyEmail: {
          title: "Contact Email Address",
          type: "string",
          format: "email"
        },
        otherPartyAddress: {
          title: "Address",
          type: "string"
        }
      }
    },
    theft: {
      type: "object",
      title: "Theft",
      properties: {
        theftalarmWorking: {
          title: "Is there a working alarm at the insured premise where loss or damage took place?",
          type: "boolean"
        },
        theftalarmReport: {
          title: "Alarm activation report attached?",
          type: "boolean"
        },
        theftforcedEntry: {
          title: "Proof of forcible entry (e.g. repair invoice) attached?",
          type: "boolean"
        },
        theftDescription: {
          title: "Full description of how entry was gained at the property",
          type: "string"
        }
      }
    },
    description: {
      type: "object",
      title: "Description",
      properties: {
        eventDescription: {
          title: "Description",
          type: "string"
        }
      }
    },
    itemsClaimed: {
      type: "object",
      title: "Items Claimed",
      properties: {
        itemsClaimedArr: {
          title: "Items Claimed",
          type: "array",
          items: [{
            key: "item1",
            type: "object",
            properties: {
              itemsClaimedDescription: {
                type: "string",
                title: "Description of items that are being claimed for"
              },
              itemsClaimedDateReplaced: {
                type: "string",
                title: "Date replaced",
                format: "date"
              },
              itemsClaimedCost: {
                type: "number",
                title: "Cost of replacement"
              }
            }
          }]
        },
        itemsClaimedDocs: {
          title: "Supporting documents",
          type: "array",
          items: {
            type: "object",
            properties: {
              attachment: {
                type: "array",
                title: "Attachment",
                items: [{
                  key: "attachName",
                  title: "Title",
                  type: "string",
                  maxLength: 200
                }, {
                  key: "attachmentContent",
                  type: "array",
                  title: "Attachment",
                  items: {
                    type: "string",
                    format: "data-url"
                  }
                }]
              }
            }
          }
        }
      }
    },
    declaration: {
      type: "object",
      title: "Declaration",
      required: ["insuredaccepttc"],
      description: "I/we declare that to the best of my / our knowledge the above statements are true. I acknowledge that the information set out above is provided freely so that Western may process my claim and give effect to the terms and conditions contained in the policy wording. I herewith give my consent that Western may use this information, my personal information on record and additional information obtained from other sources in order to determine whether to accept or reject my claim and take all necessary steps ancillary thereto to give effect hereto. I understand that I may be liable for output VAT in terms of section 8(8) of the VAT Act 89 of 1991.",
      properties: {
        insuredaccepttc: {
          type: "boolean",
          title: "Accept terms and conditions",
          description: "Tick box to accept terms and conditions"
        },
        insuredcapcity: {
          type: "string",
          title: "Capacity"
        },
        insureddate: {
          type: "string",
          title: "Date",
          format: "date"
        }
      }
    }
  }
};

export var uiSchema = {
  policeplaceReported: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  otherPartyAddress: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  eventDescription: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  },
  incidentCause: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 5
    }
  }
};